import React, { Component } from 'react';
import { Col, Container, Row, Badge, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, UncontrolledDropdown } from 'reactstrap';
import PropTypes from 'prop-types';

import { AppAsideToggler, AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import '../../css/container/DefaultHeader.css';
import AxiosInstance from '../../components/AxiosInstance/AxiosInstance';
import Logout from '../../components/Logout/Logout';
import * as signalR from '@aspnet/signalr';
import Language from '../../components/Language/Language';
import * as blobUtil from 'blob-util';

const sygnet = process.env.PUBLIC_URL + '/assets/img/logo/tricor-single.png';


const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

var dcFileOwnerID;
var p_dctbWFLtTransactionID;
var tbWFLtBCMTransactionID;
var sFileOwnerType_Logo; //


class DefaultHeader extends Component {

  constructor(props) {
    super(props);


    dcFileOwnerID = "1.00"; // dcFileOwnerID = p_dcOwnerID
    p_dctbWFLtTransactionID = "-1";
    tbWFLtBCMTransactionID = "-1";
    sFileOwnerType_Logo = "QRADAR_LOGO"; // p_sOwnerType = sFileOwnerType_Logo
    this.DisplayLogo = this.DisplayLogo.bind(this);
    this.Attachment = this.Attachment.bind(this);
    this.DisplayLogo();

    this.state = {
      userID: null,
      taskList: [],
      taskListCount: 0,
      hubConnection: null,
      NewQRadar_userName: null,
      Logo: '',
      menuAccessData: [],
      UserImage: sessionStorage.getItem("NewQRadar_userImage") !== null ? sessionStorage.getItem("NewQRadar_userImage") : process.env.PUBLIC_URL + "/assets/img/avatars/dummy.jpg"
    };

    this.Redirect = this.Redirect.bind(this);
    this.handleClick = this.handleClick.bind(this);
    //this.GetMyTaskCount();
    this.GetMyTask();
    this.loadHeaderMenu();
  }

  DisplayLogo() {
    AxiosInstance({
      method: "post",
      url: "tbSYS_m_FileStorage/usp_tbSYS_m_FileStorage_SelectAllByWLFID_Ex",
      data: {
        dcFileOwnerID: dcFileOwnerID,
        sFileOwnerType: sFileOwnerType_Logo,
        dctbWFLtTransactionID: p_dctbWFLtTransactionID,
        dctbWFLtBCMTransactionID: tbWFLtBCMTransactionID
      }
    })
      .then(response => {
        if (response != 'undefined' && response != undefined) {
          if (response.data.length > 0) {
            this.Attachment(response.data[0].fileID, response.data[0].fileContextType, sFileOwnerType_Logo)
          } else {
            this.setState({
              Logo: process.env.PUBLIC_URL + '/assets/img/logo/tricor-large.png'
            })
          }
        }
      })
      .catch(function (error) {
      });
  }

  Attachment(FileId, FileContextType, FileOwnerType) {
    AxiosInstance({
      method: "post",
      url: "tbGEN_t_Attachment/usp_tbGEN_t_Attachment_SelectAttachmentByID",
      data: {
        tbSYSmFileStorageID: FileId
      }
    })
      .then(response => {
        if (response.data != "") {
          var blob = blobUtil.base64StringToBlob(response.data);
          this.setState({
            Logo: URL.createObjectURL(blob)
          })
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  GetMyTask() {
    AxiosInstance
      ({
        method: 'post',
        url: 'tbSTD_m_MyTask/SelectMyTask',
        data: {
          sType: "Header",
          sFilterby: 'All',
          sectionID: 0,
        }
      })
      .then(response => {
        if (response != undefined) {

          //for (var i = 0; i < response.data.length; i++) {

          //  this.setState({ taskList: response.data });
          //}

          var TotalTask = 0;
          for (var i = 0; i < response.data.length; i++) {
            TotalTask = TotalTask + response.data[i].count;
          }

          this.setState({ taskList: response.data, taskListCount: TotalTask });
        }

      });
  }

  GetMyTaskCount() {
    AxiosInstance
      ({
        method: 'post',
        url: 'tbSTD_m_MyTask/SelectMyTask',
        data: {
          sType: "Header",
          sFilterby: 'All'
        }
      })
      .then(response => {
        if (response != undefined) {
          var TotalTask = 0;
          for (var i = 0; i < response.data.length; i++) {

            TotalTask = TotalTask + response.data[i].count;
          }

          this.setState({ taskListCount: TotalTask });
        }
      });
  }

  GetUserID() {
    AxiosInstance
      ({
        method: 'post',
        url: 'tbSYS_m_User/GetUserID',
      })
      .then(response => {
        if (response != undefined) {
          this.setState({ userID: response.data });
          this.SethubConnection();
          this.GetUserDetails();
        }
      });
  }

  GetUserDetails() {
    var userID = this.state.userID;

    AxiosInstance
      ({
        method: 'post',
        url: 'tbSYS_m_User/usp_tbSYS_m_User_SelectByID',
        data: {
          tbSYSmUserID: userID
        }
      })
      .then(response => {
        if (response != undefined) {
          this.setState({ NewQRadar_userName: response.data.userName });
          sessionStorage.setItem("NewQRadar_userName", response.data.userName);
        }
      });
  }

  SethubConnection() {
    //For HTTPS environment or Websocket environment
    //const hubConnection = new signalR.HubConnectionBuilder()
    //  .withUrl(process.env.REACT_APP_NOTIFICATION_URL + "notificationHub", {
    //    skipNegotiation: true,
    //    transport: signalR.HttpTransportType.WebSockets
    //  })
    //  .build();

    //For HTTP environment
    const hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(process.env.REACT_APP_NOTIFICATION_URL + "notificationhub", {
        transport: signalR.HttpTransportType.None | signalR.HttpTransportType.LongPolling
      })
      .build();

    this.setState({ hubConnection }, () => {

      this.state.hubConnection
        .start()
        .then(() => hubConnection.invoke('AddToGroup', this.state.userID))
        .catch(err => console.log('Error while establishing connection :('));

      this.state.hubConnection.on('TaskNotification', (receivedMessage) => {
        const taskListCount = this.state.taskListCount + 1;
        const newItem = [];
        newItem.push(receivedMessage);
        const newList = newItem.concat(this.state.taskList);
        if (newList.length > 5) {
          newList.splice(-1, 1);
        }
        this.setState({ taskList: newList });
        this.setState({ taskListCount: taskListCount });
      });
    });

  }

  componentDidMount = () => {
    this.GetUserID();
  };

  handleClick(e) {
    e.preventDefault();

    Logout.helper();

    this.UpdateUserStatus();
  }

  UpdateUserStatus() {
    AxiosInstance({
      method: 'POST',
      url: 'tbSEC_b_User/usp_tbSEC_b_User_Update',
      withCredentials: true,
      errorHandler: true,
      data: {
        UserStatus: 'ACT'
      }
    })
      .then(response => {
      })
      .catch(function (error) {
      });
  }

  Redirect(url) {
    window.location.hash = url;
  }

  loadHeaderMenu() {
    // Access Rgiths Checking
    AxiosInstance({
      method: 'Post',
      url: '/tbSYS_m_GroupMember/usp_tbSYS_b_GroupMember_SelectAllWtbSYSmUserIDLogic',
      errorHandle: true
    })
      .then(response => {

        if (typeof response !== 'undefined' || response !== null) {
          if (response.data.length > 0) {
            var menuAccessData = response.data;

            if (menuAccessData.filter(e => e.tbSYSmGroupID == 22).length > 0) {
              sessionStorage.setItem("NewQRadar_BCM_userGroup", "BCM_Admin");
            }
            else if (menuAccessData.filter(e => e.tbSYSmGroupID == 21).length > 0) {
              sessionStorage.setItem("NewQRadar_BCM_userGroup", "BCM_User");
            }

            this.setState({
              menuAccessData: menuAccessData,
            });
          }
        }
      })
      .catch(function (error) {
      });
  }

  render() {
    var self = this;
    Language.BindLanguageControl();
    // eslint-disable-next-line
    const { children, ...attributes } = this.props;
    return (
      <React.Fragment>

        <Container fluid={true} className="headerFrame">

          <Col xl="3" lg="3" md="10" sm="10" xs="10" className="d-flex justify-contents-center  align-items-center headerBrand">
            <div className="headerLogo">
              <AppNavbarBrand
                full={{ src: this.state.Logo, width: 140, height: 45, alt: 'Q-Rader Logo' }}
                minimized={{ src: sygnet, width: 40, height: 40, alt: 'Q-Rader Logo' }}
              />
            </div>
            <div className="nav-toggler d-flex justify-contents-center  align-items-center">
              <AppSidebarToggler className="d-lg-none side-toggler-md" display="md" mobile />
              <AppSidebarToggler className="d-md-down-none side-toggler-lg" display="lg" />
            </div>
          </Col>


          <Col xl="9" lg="9" md="2" sm="2" xs="2" className="d-flex">
            <Nav className="d-md-down-none" navbar>
              {this.state.menuAccessData.filter(e => e.tbSYSmGroupID == 21 || e.tbSYSmGroupID == 22).length > 0 &&
                <NavItem className="">
                  <NavLink className="header-nav" href="#" onClick={() => this.props.action("BCM Dashboard")} >BCM Dashboard</NavLink>
                </NavItem>
              }
              {this.state.menuAccessData.filter(e => e.tbSYSmGroupID == 21 || e.tbSYSmGroupID == 22).length > 0 &&


                <UncontrolledDropdown className="" inNavbar>
                  <DropdownToggle className="header-nav" nav caret >BCM Module</DropdownToggle>
                  <DropdownMenu>
                    {this.state.menuAccessData.filter(e => e.tbSYSmGroupID == 22).length > 0 &&
                      <DropdownItem onClick={() => this.props.action("BCM Admin")}>BCM Admin</DropdownItem>
                    }
                    {this.state.menuAccessData.filter(e => e.tbSYSmGroupID == 21).length > 0 &&
                      <DropdownItem onClick={() => this.props.action("BCM User")}>BCM User</DropdownItem>
                    }
                    {this.state.menuAccessData.filter(e => e.tbSYSmGroupID == 21 || e.tbSYSmGroupID == 22).length > 0 &&
                      <DropdownItem onClick={() => this.props.action("BCM Report")}>BCM Report</DropdownItem>
                    }
                    {this.state.menuAccessData.filter(e => e.tbSYSmGroupID == 21 || e.tbSYSmGroupID == 22).length > 0 &&
                      <DropdownItem onClick={() => this.props.action("BCM FAQ")}>BCM FAQ</DropdownItem>
                    }
                  </DropdownMenu>
                </UncontrolledDropdown>
              }
              {/*
              <NavItem className="">
                <NavLink className="header-nav" href="#" onClick={() => this.props.action("BCM Report")} >BCM Report</NavLink>
              </NavItem>
              */}
              {/* 
              <NavItem className="">
                <NavLink className="header-nav" href="#" onClick={() => this.props.action("BCM User")}>BCM User</NavLink>
              </NavItem>

              <NavItem className="">
                <NavLink className="header-nav" href="#" onClick={() => this.props.action("BCM Admin")}>BCM Admin</NavLink>
              </NavItem> */}
              {this.state.menuAccessData.filter(e => e.tbSYSmGroupID == 13).length > 0 &&
                <NavItem className="">
                  <NavLink className="header-nav" href="#" onClick={() => this.props.action("System Admin")}>System Admin</NavLink>
                </NavItem>
              }
            </Nav>



            <Nav className="ml-auto" navbar>
              <UncontrolledDropdown nav direction="down">
                <DropdownToggle nav className="background-none d-md-down-none" display="lg">
                  <i className="icon-bell"></i><Badge pill color="danger">{this.state.taskListCount}</Badge>
                </DropdownToggle>
                <DropdownMenu right style={{ right: 'auto' }} >
                  <DropdownItem header tag="div" className="cardSubtitle dropdown-header"><strong>Latest Notification</strong></DropdownItem>
                  {
                    this.state.taskList.filter(e => e.count != 0).map(function (task, i) {
                      return <DropdownItem key={i}><i className="fa fa-bell-o"></i><Badge pill color="danger">{task.count}</Badge> <h6 className="dropdownText"><a href="javascript:void(0)" onClick={() => self.Redirect(task.url)} >{task.section}</a></h6></DropdownItem>
                    })
                  }
                </DropdownMenu>
              </UncontrolledDropdown>
              {/*
              <AppHeaderDropdown direction="down">
                <DropdownToggle nav className="background-none d-md-down-none" display="lg">
                  <i className="icon-list"></i><Badge pill color="warning">5</Badge>
                </DropdownToggle>
                <DropdownMenu right style={{ right: 'auto' }}>
                  <DropdownItem header tag="div" className="cardSubtitle dropdown-header"><strong>Latest Tasks</strong></DropdownItem>
                  <DropdownItem><i className="fa fa-bell-o"></i> <h6 className="dropdownText">Updates</h6></DropdownItem>
                  <DropdownItem><i className="fa fa-bell-o"></i><h6 className="dropdownText"> Updates</h6></DropdownItem>
                  <DropdownItem><i className="fa fa-bell-o"></i> <h6 className="dropdownText">Updates</h6></DropdownItem>
                  <DropdownItem><i className="fa fa-bell-o"></i> <h6 className="dropdownText">Updates</h6></DropdownItem>
                  <DropdownItem><i className="fa fa-bell-o"></i><h6 className="dropdownText"> Updates</h6></DropdownItem>
                </DropdownMenu>
              </AppHeaderDropdown>
              */}
              <UncontrolledDropdown nav direction="down">
                <DropdownToggle nav className="background-none">
                  <img src={this.state.UserImage} className="img-avatar" alt="admin@bootstrapmaster.com" />
                </DropdownToggle>
                <DropdownMenu right style={{ right: 'auto' }}>
                  {/*<DropdownItem header tag="div" className="cardSubtitle dropdown-header"><strong>Account</strong></DropdownItem>*/}
                  {/*<DropdownItem><i className="fa fa-bell-o"></i><h6 className="dropdownText"> Updates</h6><Badge color="info">42</Badge></DropdownItem>*/}
                  {/*<DropdownItem><i className="fa fa-envelope-o"></i><h6 className="dropdownText">Messages</h6><Badge color="success">42</Badge></DropdownItem>*/}
                  {/*<DropdownItem><i className="fa fa-tasks"></i><h6 className="dropdownText"> Tasks</h6><Badge color="danger">42</Badge></DropdownItem>*/}
                  {/*<DropdownItem><i className="fa fa-comments"></i> Comments<Badge color="warning">42</Badge></DropdownItem>*/}
                  <DropdownItem header tag="div" className="cardSubtitle dropdown-header"><strong>{Language.GetLanguageByID(28.01)}</strong></DropdownItem>
                  <DropdownItem>{this.state.NewQRadar_userName}</DropdownItem>
                  <DropdownItem header tag="div" className="cardSubtitle dropdown-header"><strong>Settings</strong></DropdownItem>
                  {/*<DropdownItem><i className="fa fa-user"></i><h6 className="dropdownText"> Profile</h6></DropdownItem>*/}
                  {/*<DropdownItem><i className="fa fa-wrench"></i><h6 className="dropdownText"> Settings</h6></DropdownItem>*/}
                  {/*<DropdownItem><i className="fa fa-usd"></i> Payments<Badge color="secondary">42</Badge></DropdownItem>
                  <DropdownItem><i className="fa fa-file"></i> Projects<Badge color="primary">42</Badge></DropdownItem>
                  <DropdownItem divider />*/}
                  {/*<DropdownItem><i className="fa fa-shield"></i><h6 className="dropdownText"> Lock Account</h6></DropdownItem>*/}
                  {/*<DropdownItem><a href="javascript:$zopim.livechat.window.show()"><i className="fa fa-wrench"></i><h6 className="dropdownText"> Support</h6></a></DropdownItem>*/}
                  <DropdownItem onClick={this.handleClick}><i className="fa fa-lock"></i><h6 className="dropdownText"> Logout</h6></DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>



            {/*<AppAsideToggler className="d-md-down-none" />*/}
            {/*<AppAsideToggler className="d-lg-none" mobile />*/}
          </Col>
        </Container>
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default DefaultHeader;
